<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="summary-card" @click.stop="toggleCards">
    <div class="business-process-name xtium-title">
      {{ businessProcess.name }}
    </div>
    <div class="business-process-endpoint">
      {{ businessProcess.endPoint }}
    </div>
    <div class="information-buttons">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="passive-information-item" v-bind="attrs" v-on="on" @click="onActionClick('agents')">
            <v-icon>mdi-account</v-icon>
            {{ businessProcess.agentsAssigned.length }}
          </v-btn>
        </template>
        <span>{{ $t('licensingSummary.agents') }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="passive-information-item" v-bind="attrs" v-on="on" @click="onActionClick('supervisors')">
            <v-icon>mdi-account-supervisor</v-icon>
            {{ businessProcess.supervisorsAssigned.length }}
          </v-btn>
        </template>
        <span>{{ $t('licensingSummary.supervisors') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcsPassiveBusinessProcessSummaryCard',
  props: {
    businessProcess: {
      type: Object,
      required: true
    },
    toggleCards: {
      type: Function,
      required: true
    },
    onActionClick: {
      type: Function,
      required: true
    }
  }
};
</script>

<style scoped>
.summary-card {
  display: grid;
  grid-template-rows: min-content auto 60px;
  height: 100%;
}
.passive-information-item {
  font-size: 20px;
  grid-template-columns: auto auto;
}
.business-process-endpoint {
  font-size: 22px;
  color: var(--v-primary-base);
  padding: 0 16px;
}
.business-process-name {
  font-size: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  padding: 16px 16px 0;
}
.information-buttons {
  display: grid;
  grid-template-columns: auto auto;
  opacity: 0.75;
  padding: 12px 16px;
  background-color: #0001;
}
</style>
